<template>
  <div class="editor">
    <header>
      <editorHeader>
      </editorHeader>
    </header>
    <main>
      <editorMain>

      </editorMain>
    </main>
  </div>
</template>
<script>
import editorHeader from "../editor/editor-header/index";
import editorMain from "../editor/editor-main/index";
import { mapGetters } from 'vuex';
export default {
  name: "editor",
  data() {
    return {

    }
  },
  components: {
    editorHeader,
    editorMain
  },
  computed: {
    ...mapGetters('editor', [
      'getThemeInfo',                // 主题信息
      'getUrlInfo',                  // 获取路由信息
      'getTaskContentListParams',    // 列表接口基础参数
    ]),
    ...mapGetters({
      getLoadingInfo: 'editor/getLoading',  // 获取加载信息
    }),
  },
  created() {
    // 将路由信息 存储vuex
    const queryInfo = JSON.parse(this.$Base64.decode(this.$route.query.key)) || {};
    this.$store.dispatch('editor/setUrlInfo', queryInfo)
    this.setThemeInfoForStrorage()
  },
  async mounted() {
    this.$nextTick(() => {
      window.addEventListener("unload", (e) => this.unload(e));
    })
    const theme = [{ value: 'standard', label: '普通模式' }, { value: 'dark', label: '夜间模式', }, { value: 'eye-protection', label: '护眼模式' }]
    this.$store.dispatch('editor/updateTheme', theme)
    let options = [];
    let sourceItem = {
      value: 'source',
      label: '原文',
    };
    options.push(sourceItem);
    let translateItem = {
      value: 'translate',
      label: '翻译',
      children: [{
        value: 'target-1',
        label: '翻译:译文'
      }, {
        value: 'source-target-2',
        label: '翻译:原译对照'
      }]
    };
    options.push(translateItem);
    this.$store.dispatch('editor/updateImportOption', options)
    this.getFileInfo();
    this.getFileContent();
  },
  methods: {
    //获取文件
    async getFileInfo() {
      let params = Object();
      console.log(this.getUrlInfo)
      const { fileId } = this.getUrlInfo
      Reflect.set(params, 'id', fileId);
      this.$store.dispatch('editor/getFileInfo', params)
    },

    //获取文件内容
    getFileContent() {
      const { type, fileId, taskType } = this.getUrlInfo
      const marker = type === 'project' ? 2 : 1
      const params = {
        ...this.getTaskContentListParams,
        marker,
        comparedHighlight: 0,
        showTerm: 1,
        transFileId: fileId,
        taskType: taskType || 1
      }
      Reflect.deleteProperty(params, 'taskId');
      this.$store.dispatch('editor/getFileContent', params)
    },
    unload(e) {
      // localStorage.setItem('theme', 'standard')
      // this.$store.dispatch('editor/setThemeInfo', 'standard')
    },
    setThemeInfoForStrorage(){
      let themeInfo = localStorage.getItem('theme')
      this.$store.dispatch('editor/setThemeInfo', themeInfo)
    },
  },
  destroyed() {
    this.$store.commit('editor/INIT_EDITOR_STATE', {})
    // this.setEditorMode('standard');
    window.removeEventListener("unload", (e) => this.unload(e));
  },
}
</script>
<style lang="less" scoped>
@import "./assets/style.less";
</style>